// @flow
import * as React from 'react';
import clsx from "clsx";
import {emptyCategory} from "repositories/category/CategoryRepository";

type Props = {
  prodOpen: boolean;
  handleClick;
  getTranslation;
  products;
};
export const UlProdKind = ({products, prodOpen, handleClick, getTranslation}: Props) => {
  return (
    <ul className={clsx("select-list", "prod-kind-list",)}
      style={{display: prodOpen ? 'block' : 'none'}}>
      <li
        onClick={(e) => handleClick(e, 'prod-click', emptyCategory)}>{getTranslation("I18N_SEARCH_FILTER_ALL")}
      </li>
      {products.map(product => (<li key={product.name} onClick={(e) => handleClick(e, 'prod-click', product)}>
        {product.name}
      </li>))}
    </ul>
  );
};